import { Grid, MenuItem } from "@material-ui/core";
import React from "react";
import Pagination from "react-js-pagination";
import { NEW_ITEMS_LIMIT } from "../../../constants";
import CustomInput from "../Input";
import angleRight from "../../../assets/icons/rightArrow.svg";
import angleLeft from "../../../assets/icons/leftArrow.svg";
import "./new_footer_pagination.scss";
export default function NewFooterPagination(props) {
  const { itemProps, title, totalLength, paginationProps } = props;

  return (
    <Grid container className="newfooterPagination">
      <Grid item lg={12}>
        <div
          className={`new_show__option ${
            props.addDashboardCss ? "mt-15" : ""
          } `}
        >
          <ul>
            <li>
              {totalLength > paginationProps.itemsCountPerPage ? (
                <div
                  className={`newpagination ${
                    props.addDashboardCss ? "pd-10" : ""
                  }`}
                >
                  <Pagination
                    {...paginationProps}
                    pageRangeDisplayed={10}
                    itemClass="page-item"
                    linkClass="page-link"
                    hideDisabled={true}
                    hideFirstLastPages={true}
                    nextPageText={
                      <img
                        src={angleRight}
                        className="arrowPage"
                        alt="Next Step Image"
                      />
                    }
                    prevPageText={
                      <img
                        src={angleLeft}
                        className="arrowPage"
                        alt="Back Step Image"
                      />
                    }
                  />
                  {/* <span>Total : {totalLength} </span> */}
                </div>
              ) : (
                ""
              )}
            </li>
            {!props.hideShow && (
              <>
                {" "}
                <li>Rows </li>
                <li className="limit-button">
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                      margin: "normal",
                      className: "add-screen-formcontrol newpageNumber",
                    }}
                    inputProps={{
                      ...itemProps,
                      className: "input-add-screen mt-0 text-center",
                      select: true,
                    }}
                  >
                    {NEW_ITEMS_LIMIT.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </CustomInput>
                </li>
              </>
            )}
            <span className="footer-items-float-right">
              {totalLength !== 0 ? (
                <li style={{ marginRight: "14px" }}>Showing {title}</li>
              ) : (
                ""
              )}
              <li>Total Data : {totalLength}</li>
            </span>

            {/* {totalLength !== 0 ? <li>Showing {title}</li> : ""} */}
          </ul>
        </div>
      </Grid>
      <Grid item lg={4}></Grid>
    </Grid>
  );
}
